


























import assert from 'assert';

import { CreateElement } from 'vue';
import {
  Component,
  Vue,
} from 'vue-property-decorator';

import { ProductVariant } from '@/models';
import {
  Money,
  formatMoney,
} from '@/lib/money';

const PriceBlockProps = Vue.extend({
  props: {
    price: {
      type: [
        Object as () => Money,
        Array as () => Money[],
      ],
      required: true,
    },
  },
});

@Component
export default class PriceBlock extends PriceBlockProps {
  public created() {
    if (Array.isArray(this.price)) {
      assert.ok(!!this.price[0] && !!this.price[1],
        'specifying a price range without any meaningful prices');
    }
  }

  get normalizedPrice(): [Money] | [Money, Money] {
    if (!Array.isArray(this.price)) {
      return [this.price];
    } else {
      const price1 = this.price[0];
      const price2 = this.price[1];
      assert.ok(price1.currency === price2.currency,
        `specifying prices with different currencies ${price1.currency} v.s ${price2.currency}`);

      if (price1) {
        if (price2) {
          if (price1.amount.equals(price2.amount)) {
            return [price1];
          } else if (price1.amount.lessThan(price2.amount)) {
            return [price1, price2];
          } else {
            return [price2, price1];
          }
        } else {
          return [price1];
        }
      } else {
        // price2 should be defined as chekced in `created`.
        return [price2!];
      }
    }
  }

  public formatMoney(price: Money) {
    return formatMoney(price);
  }
}

